function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { ApiProvider } from '@leverege/api-redux';
import I18N from '@leverege/i18n';
import { Flex, Label, Pane, TextInput, Toast } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import DefaultRoleSelector from "../role/RoleSelector.js";
const {
  t
} = I18N.ns('apiAccessKeyManagement.apiAccessKey.AddEditApiAccessKeysEditor');
export default class AddEditApiAccessKeysEditor extends React.Component {
  static contextType = ApiProvider.Context;
  constructor(props) {
    super(props);
    this.state = {
      name: props?.apiAccessKey?.name || '',
      roles: []
    };
  }
  async componentDidMount() {
    const roles = await this.getRoles();
    this.setState({
      roles,
      originalRoles: roles
    }, this.onChange);
  }
  getRoles = async () => {
    const {
      actions,
      apiAccessKey
    } = this.props;
    let roles = [];
    if (apiAccessKey) {
      try {
        const res = await GlobalState.dispatch(actions.user(apiAccessKey.id).roles());
        roles = res.items;
      } catch (error) {
        Toast.error([t('toastError'), error.message]);
      }
    }
    return roles;
  };
  onNameChange = event => {
    this.setState({
      name: event.value
    }, this.onChange);
  };
  onRoleChange = event => {
    this.setState({
      roles: event.value
    }, this.onChange);
  };
  onChange = () => {
    const {
      onChange,
      eventData
    } = this.props;
    const {
      name,
      roles,
      originalRoles
    } = this.state;
    onChange({
      data: eventData,
      value: {
        name,
        roles,
        originalRoles
      }
    });
  };
  render() {
    const {
      projectId,
      roleSelector: RoleSelector = DefaultRoleSelector,
      selectorProps
    } = this.props;
    const {
      apiAccessKey,
      name,
      roles
    } = this.state;
    return /*#__PURE__*/React.createElement(Pane, {
      variant: selectorProps?.variants?.editorPane,
      layout: "flex:colL"
    }, /*#__PURE__*/React.createElement(Flex, {
      variant: "colS"
    }, /*#__PURE__*/React.createElement(Label, {
      variant: selectorProps?.variants?.inputLabel
    }, t('name')), /*#__PURE__*/React.createElement(TextInput, {
      variant: selectorProps?.variants?.inputValue,
      onChange: this.onNameChange,
      value: name
    })), /*#__PURE__*/React.createElement(RoleSelector, _extends({}, selectorProps, {
      projectId: projectId,
      user: apiAccessKey,
      value: roles,
      variants: selectorProps?.variants,
      roleFilter: selectorProps?.roleFilter,
      onChange: this.onRoleChange,
      requireRoles: true
    })));
  }
}